package team.platforma.multiplatform_material_extension.ui.buttons.utils

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextStyle

class ButtonText(
    val text: String = "",
    val textStyle: TextStyle = TextStyle.Default,
    val gravity: TextGravity = TextGravity.Center,
    private var annotatedString: AnnotatedString? = null
) {
   fun setAnnotatedString(annotatedString: AnnotatedString) : ButtonText {
       this.annotatedString = annotatedString
       return this
   }

    internal fun getAnnotatedString() : AnnotatedString? {
        return annotatedString
    }
}